import './helpzone.component.ajscss';

import { ChatCopyService } from '@agent/agent-interface/contact-view/chat/services/chat-copy.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IContactStatusDeprecatedService } from '@agent/core/contact/contact-status-deprecated.service';
import { KNOWLEDGEBASE_RESULT_AVAILABLE, KnowledgeBaseService } from '@agent/core/knowledge-base/knowledge-base.service';
import { IScriptArgumentService } from '@agent/core/phone/script-argument/script-argument.service';
import { DisplayModeService } from '@agent/core/settings/display-mode.service';
import { KnowledgeBaseFacade } from '@agent/core/store/knowledge-base/knowledge-base.facade';
import { ChatAssistanceService } from '@commons/chat-assistance/chat-assistance.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import { IContact } from '@commons/models/contact';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentOptions } from 'angular';
import { i18n } from 'i18next';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import {
  BookingFacade,
  BookingStatus,
  ChannelDirection,
  ChannelType,
  Configuration,
  isNotNullOrUndefined,
  MessagingService,
  None,
  Option,
} from '@contact/upgrade';

import templateUrl from './helpzone.component.ajs.html';
import { ResponseModel } from './knowledge-base/models/responseModel';
import { KnowledgeBaseOwiService } from './knowledge-base/owi/services/knowledge-base-OWI.service';
import { HelpzoneType } from './models/helpzone';
import { SurveyType } from './survey-view/models/survey';
import { ISurveyService } from './survey-view/survey.service';

const MODULE_NAME = 'cngHelpzone';

export interface ISurveyContact {
  contactId: string;
  surveyQuestionnaireList: any[];
}

export class HelpzoneCtrl {
  public name = MODULE_NAME;
  public HelpzoneType = HelpzoneType;

  public showHelpzone: boolean;
  public hasScriptActive: boolean = false;
  public hasChatAssistancePermission: boolean = false;
  public isSurveyExist: boolean = false;
  public surveyIsAutomatic: boolean = false;
  public surveyIsManual: boolean = false;
  public surveyIsManualAndValid: boolean = false;
  public surveyIsAutomaticAndVocal: boolean = false;
  public selectedResponseId: string | undefined;
  private helpzoneActive: { [type: string]: boolean };
  private contactSurveyChildren: any = {};
  private jsonFilterForSurvey: any = { teamsId: [], campaignId: '', contactId: '', channel: '' };
  private surveyQuestionnaireList: any[];
  private surveyQuestionnaireListArchive: ISurveyContact[] = [];
  private openChatPanelSubscription: Subscription;
  private contact: Option<IContact> = None;
  public isNewMDR: boolean = false;
  public displayOWI: boolean = false;
  public displayKnowledgeBase: boolean = false;
  public displayOWIReportError: boolean = false;
  public displayEpticaKnowledgeBase: boolean = false;
  public displayAllChannelEpticaKnowledgeBase: boolean = false;
  public mediaExternalId: string = '';
  public isKnowledgeBaseFrameEnabled = this.configuration.isKnowledgeBaseFrameEnabled ?? false;

  constructor(
    private readonly $i18next: i18n,
    private readonly sessionDeprecatedService: SessionDeprecatedService,
    private readonly contactStatusDeprecatedService: IContactStatusDeprecatedService,
    private readonly chatAssistanceService: ChatAssistanceService,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly scriptArgument: IScriptArgumentService,
    private readonly surveyService: ISurveyService,
    private readonly copyService: ChatCopyService,
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private readonly messagingService: MessagingService,
    private readonly contactFacade: BookingFacade,
    private readonly displayModeService: DisplayModeService,
    private readonly knowledgeBaseOwiService: KnowledgeBaseOwiService,
    private readonly knowledgeBaseFacade: KnowledgeBaseFacade,
    private readonly configuration: Configuration,
    private readonly knowledgeBaseService: KnowledgeBaseService
  ) {
    this.hasChatAssistancePermission = this.sessionDeprecatedService.hasPermission('CSR::supervisor:chat_assistance');

    // intialize show view
    this.helpzoneActive = Object.keys(HelpzoneType).reduce(
      (arr, type) => ({
        ...arr,
        [type]: false,
      }),
      {}
    );
  }

  get contactResponseId(): string {
    return this.contact.map(contact => contact.responseId).getOrElse('');
  }

  get contactChannelType(): ChannelType {
    return this.contact.map(contact => contact.channel.type).getOrElse(ChannelType.NOTSET);
  }

  $onInit() {
    this.displayOWI = this.sessionDeprecatedService.hasPermission('CSR::answer_models:display');
    this.displayKnowledgeBase = this.sessionDeprecatedService.hasPermission('CSR::knowledge_database:display');
    this.displayOWIReportError = this.sessionDeprecatedService.hasPermission('CSR::bad_answer_models:report');
    this.displayEpticaKnowledgeBase = this.sessionDeprecatedService.hasPermission('CSR_MAIL_INCOMING::contact:mail_ask_knowledge');
    this.displayAllChannelEpticaKnowledgeBase = this.sessionDeprecatedService.hasPermission('CSR::self:knowledgedatabase');

    // Booking state allocated
    this.contactDeprecatedService
      .contactState$()
      .pipe(
        filter(event => event.state === BookingStatus.IN_PROCESS),
        ng1Destroy(this)
      )
      .subscribe(event => {
        this.scriptArgument
          .getScriptAgent(event.contact)
          .then(() => {
            this.hasScriptActive = true;
          })
          .catch(() => (this.hasScriptActive = false));
      });

    // Booking state closed
    this.contactDeprecatedService
      .contactState$()
      .pipe(
        filter(event => event.state === BookingStatus.CLOSED),
        ng1Destroy(this)
      )
      .subscribe(() => {
        this.hasScriptActive = false;
        this.selectedResponseId = undefined;

        // close panel if focused
        if (this.isActive(HelpzoneType.SCRIPTING)) this.closePanel();
      });

    // Booking updated
    this.contactDeprecatedService
      .contactUpdated$()
      .pipe(ng1Destroy(this))
      .subscribe(data => (this.contact = Option.of(data)));

    // Booking selected
    const contact$ = this.contactFacade.selected$.pipe(isNotNullOrUndefined());
    contact$.pipe(ng1Destroy(this)).subscribe(contact => {
      this.selectedResponseId = contact.responseId;
      this.contact = Option.of(contact);
      this.getSurveyAgent();
    });

    // contact state success
    this.contactStatusDeprecatedService
      .success()
      .pipe(ng1Destroy(this))
      .subscribe(event => {
        if (event.newState === BookingStatus.IN_PROCESS) {
          this.getSurveyAgent();
        } else if (event.newState === BookingStatus.CLOSED) {
          this.isSurveyExist = false;
          this.surveyQuestionnaireListArchive = this.surveyQuestionnaireListArchive.filter(c => c.contactId !== event.id);
          this._onChangeShowArea();
        }
      });

    this.chatAssistanceService.connect();

    this.openChatPanelSubscription = this.copyService.isPanelOpen$.subscribe(result => {
      if (result && !this.isActive(this.HelpzoneType.CHAT)) {
        this.resetNbUnreadMessages();
        this.manageActive(this.HelpzoneType.CHAT);
      }
    });

    // only display the red asterix if the panel is closed
    this.messagingService
      .forLocal()
      .listen$(KNOWLEDGEBASE_RESULT_AVAILABLE)
      .pipe(
        filter(() => !this.isActive(HelpzoneType.KNOWLEDGE_BASE)),
        ng1Destroy(this)
      )
      .subscribe(() => (this.isNewMDR = true));

    this.knowledgeBaseFacade.suggestedResults$
      .pipe(
        filter(() => !this.isActive(HelpzoneType.KNOWLEDGE_BASE)),
        ng1Destroy(this)
      )
      .subscribe((suggestedResults: ResponseModel[]) => {
        if (suggestedResults.length) {
          this.isNewMDR = true;
        }
      });

    this.contactFacade.selected$.subscribe(contact => {
      this.mediaExternalId = '';
      if (contact) {
        switch (contact.channel.type) {
          case ChannelType.SOCIAL_NETWORK:
          case ChannelType.CHAT:
            this.mediaExternalId = contact.responseId;
            break;
          case ChannelType.MAIL:
          case ChannelType.UNITARY_MAIL:
            contact.epticaRequestId ? (this.mediaExternalId = contact.epticaRequestId.toString()) : (this.mediaExternalId = '');
            break;
          default:
            this.mediaExternalId = '';
        }

        if (this.displayOWI) {
          this.knowledgeBaseOwiService.checkSuggestionsForMedia();
        }
      }
    });
  }

  $onDestroy() {
    this.chatAssistanceService.disconnect();
    this.openChatPanelSubscription.unsubscribe();
    this.copyService.isPanelOpen$.next(false);
  }

  manageActive(type: HelpzoneType) {
    // inverse show boolean for given type
    Object.keys(this.helpzoneActive).forEach(cType => {
      if (type !== HelpzoneType[cType]) {
        this.helpzoneActive[cType] = false;
      } else {
        this.helpzoneActive[cType] = !this.helpzoneActive[cType];
      }
    });
    // inform parent component
    this._onChangeShowArea();
  }

  isActive(type: HelpzoneType): boolean {
    return this.helpzoneActive[type];
  }

  closePanel() {
    // reset show view
    Object.keys(this.helpzoneActive).forEach(type => (this.helpzoneActive[type] = false));
    // inform parent component
    this._onChangeShowArea();
  }

  // send the notification to the knowledge base service
  sendNotification() {
    if (this.isKnowledgeBaseFrameEnabled) {
      this.knowledgeBaseService.notifyAnswerKO(this.knowledgeBaseService.getKnowledgeRequestId()).subscribe((success: boolean) => {
        if (success) {
          // reset the frame
          this.knowledgeBaseService.resetKnowledgeBaseFrame();
          // success toast
          this.toastDeprecatedService.notify(this.$i18next.t('agent:panel.knowledge_base.notif_ko_ok'), 5000);
        }
      });
    } else {
      this.knowledgeBaseOwiService.sendKoResponse(this.mediaExternalId).subscribe((data: any) => {
        if (!data.codeError) {
          this.toastDeprecatedService.notify(this.$i18next.t('agent:panel.knowledge_base.notif_ko_ok'), 5000);
        } else {
          this.toastDeprecatedService.alert(this.$i18next.t('agent:panel.knowledge_base.notif_ko_ko'), 5000);
        }
      });
    }
  }

  closeSurvey(): void {
    this.helpzoneActive[HelpzoneType.SURVEY] = false;
    this.isSurveyExist = false;
    this.surveyIsAutomatic = false;
    this.surveyIsManual = false;
    this.surveyIsManualAndValid = false;
    this.surveyIsAutomaticAndVocal = false;
  }

  isSurveyTriggered(): boolean {
    return typeof this.contactSurveyChildren.isSurveyTriggered === 'function' && this.contactSurveyChildren.isSurveyTriggered();
  }

  getNbUnreadMessages(): number {
    return this.chatAssistanceService.nbUnreadMessages();
  }

  resetNbUnreadMessages(): void {
    this.chatAssistanceService.resetNbUnreadMessages();
  }

  getSurveyAgent() {
    if (
      !this.isSurveyExist &&
      this.contact.isDefined() &&
      !(this.contact.get().channel.type === ChannelType.UNITARY_PHONE && this.contact.get().channel.direction === ChannelDirection.OUTGOING)
    ) {
      this.jsonFilterForSurvey.contactId = this.contactResponseId;
      this.jsonFilterForSurvey.channel = ChannelType[this.contact.get().channel.type];
      let contactId: string = this.contactResponseId;
      const campaign = this.contact.get().campaign;
      if (campaign) {
        this.jsonFilterForSurvey.campaignId = campaign?.campaign.id;
      }
      const archiveSurvey = this.surveyQuestionnaireListArchive.find(c => c.contactId === contactId);
      if (archiveSurvey != null) {
        this.getSurveyByQuestionnaires(archiveSurvey.contactId, archiveSurvey.surveyQuestionnaireList);
      } else {
        this.surveyService
          .getSurveyByFilter(this.jsonFilterForSurvey)
          .then(surveyByQuestionnaireList => this.getSurveyByQuestionnaires(contactId, surveyByQuestionnaireList));
      }
    }
  }

  getSurveyByQuestionnaires(contactId: string, surveyByQuestionnaireList: any[] = []) {
    this.surveyQuestionnaireListArchive.push({ contactId: contactId, surveyQuestionnaireList: surveyByQuestionnaireList });
    this.surveyIsAutomatic = false;
    this.surveyIsAutomaticAndVocal = false;
    this.surveyIsManual = false;

    // we first try to get all surveys that can be sent automatically
    // i.e. with the "AUTOMATIC" mode, and the vocal or SMS type
    const automaticSurveys = surveyByQuestionnaireList.filter(survey => {
      return (
        survey &&
        survey.surveyMode === 'AUTOMATIC' &&
        this.contactChannelType === ChannelType.PHONE &&
        (survey.channelsList.includes(SurveyType.VOCAL) || survey.channelsList.includes(SurveyType.SMS))
      );
    });
    // if there are eligigble automatic surveys
    if (automaticSurveys.length > 0) {
      this.surveyIsAutomatic = true;
      // we take a random survey from the list
      const randomSurvey = automaticSurveys[Math.floor(Math.random() * automaticSurveys.length)];
      // we remove all channels that we cannot trigger automatically with the phone number
      randomSurvey.channelsList = randomSurvey.channelsList.filter(channel => channel == SurveyType.VOCAL || channel == SurveyType.SMS);
      // we take a random channel from the selected survey's channel list
      randomSurvey.channelRandom = randomSurvey.channelsList[Math.floor(Math.random() * randomSurvey.channelsList.length)];
      this.surveyIsAutomaticAndVocal = randomSurvey.channelRandom === SurveyType.VOCAL;
      this.surveyQuestionnaireList = [randomSurvey];
      this.contactSurveyChildren.updateAutomaticSurvey(this.surveyQuestionnaireList);
    } else if (surveyByQuestionnaireList.length > 0) {
      // if there are no eligigble automatic surveys, we take the whole list as manually triggerable surveys
      this.surveyIsManual = true;
      this.surveyQuestionnaireList = surveyByQuestionnaireList;
      this.contactSurveyChildren.updateManualSurvey(this.surveyQuestionnaireList);
    }
    this.isSurveyExist = this.surveyQuestionnaireList?.length > 0;
  }

  private _onChangeShowArea() {
    // send to parent
    const state =
      this.isActive(HelpzoneType.CHAT) ||
      this.isActive(HelpzoneType.SCRIPTING) ||
      this.isActive(HelpzoneType.SEARCH) ||
      this.isActive(HelpzoneType.KNOWLEDGE_BASE) ||
      (this.isActive(HelpzoneType.SURVEY) && this.isSurveyExist);

    this.displayModeService.toggleHelpzone(state);
    this.showHelpzone = state;
  }
}

export class Helpzone implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    showHelpzone: '=',
  } as { [binding: string]: string };
  controller = [
    '$i18next',
    'sessionDeprecatedService',
    'contactStatusDeprecatedService',
    'chat-assistance',
    'contactDeprecatedService',
    'scriptArgument',
    'survey',
    'chatCopyService',
    'toastDeprecatedService',
    'messaging',
    'contactFacade',
    'displayModeService',
    'knowledgeBaseOwiService',
    'knowledgeBaseFacade',
    'configuration',
    'knowledgeBaseService',
    HelpzoneCtrl,
  ];
}

export default MODULE_NAME;
